// src/components/JoinModal.jsx
import React, { useState } from 'react';
import './JoinModal.css';
import { registerUser } from '../logic/joinLogic';
import { useNavigate } from 'react-router-dom';


const JoinModal = ({ onClose }) => {
  const [facebookName, setFacebookName] = useState('');
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const navigate = useNavigate();



  const handleJoin = async () => {
    setMessage('');
    if (!facebookName || !email || !username || !password) {
      setMessage('Please fill all fields.');
      return;
    }

    setLoading(true);
    const result = await registerUser(email, password, username, facebookName);
    setLoading(false);

    if (result.success) {
      setMessage('Registration successful!');
      setTimeout(() => {
        onClose();
        navigate('/menu'); // Or wherever you want to go after sign-up
      }, 1000);
    } else {
      setMessage(result.message);
    }
  };


  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Demande d'adhésion</h2>

        <label>
          Votre profile Facebook:
          <input
            type="text"
            placeholder="e.g. https://www.facebook.com/YGOMadagascarEsport"
            value={facebookName}
            onChange={(e) => setFacebookName(e.target.value)}
          />
        </label>

        <label>
          Adresse email:
          <input
            type="email"
            placeholder="example@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label>
          Mot de passe:
          <input
            type="password"
            placeholder="Your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>

        <label>
          Nom d'utilisateur / ID:
          <input
            type="text"
            placeholder="Your duelist username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </label>

        <div className="modal-buttons">
          <button onClick={handleJoin} disabled={loading}>Rejoindre</button>
          <button onClick={onClose}>Annuler</button>
        </div>

        {message && <p className="modal-message">{message}</p>}
      </div>
    </div>
  );
};

export default JoinModal;
